import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { BaseEditService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class MockEditService extends BaseEditService<any, any> {
  constructor() {
    super('', '', undefined, undefined);
  }

  search(
    search: string = undefined,
    id: string = undefined,
    id2: string = undefined,
    includeAll: boolean = false,
    allowIncludeAllBlankSearch = false,
    allowBlankSearch = false,
  ): Observable<any[]> {
    return of([]);
  }

  create(): Observable<any> {
    return of({} as any);
  }

  edit(id: string): Observable<any> {
    return of({});
  }

  save(model: any): Observable<string> {
    return of('');
  }

  delete(id: string): Observable<any> {
    return of({});
  }
}
